import DownloadInquiries from './DownloadInquiries';

export default DownloadInquiries;
